export const colorAccent = '00B1BA';
export const colorAccentLight = 'A3C3C8';